module.exports = __webpack_public_path__ + "media/application/images/2018/kiwi-green-92b0da279f20a278dfdaacc2633de9a0.png";